/**
 * Constants used throughout the AI Assistant application
 */

/**
 * Empty GUID constant used for delayed session initialization
 * When a session ID equals this value, it indicates the session hasn't been created yet
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

/**
 * Default spring configuration for react-spring animations
 * Matches the SPRING_CONFIG_DEFAULT from online-community/OCFE
 */
export const SPRING_CONFIG_DEFAULT = {
  tension: 170,
  friction: 26,
  clamp: false,
};

